import React from "react";

const BLUE = "#0077B5";
const GREEN = "#1D9E75";
const FONT = "-apple-system,'Segoe UI',Helvetica,sans-serif";

const cardStyle = {
  background: "#fff",
  border: "1px solid #e8e8e4",
  borderRadius: 12,
  padding: "20px 24px",
  fontFamily: FONT,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: 16,
};

const statStyle = {
  fontSize: 12,
  color: "#666",
  display: "flex",
  alignItems: "center",
  gap: 6,
};

const btnPrimary = {
  background: BLUE,
  color: "#fff",
  border: "none",
  borderRadius: 7,
  padding: "8px 16px",
  fontSize: 13,
  fontWeight: 600,
  cursor: "pointer",
  fontFamily: FONT,
  whiteSpace: "nowrap",
};

const btnSecondary = {
  background: "transparent",
  color: BLUE,
  border: `1px solid ${BLUE}`,
  borderRadius: 7,
  padding: "7px 15px",
  fontSize: 13,
  fontWeight: 500,
  cursor: "pointer",
  fontFamily: FONT,
  whiteSpace: "nowrap",
};

function StatDot({ label, value, accent }) {
  return (
    <span style={statStyle}>
      <span style={{ width: 6, height: 6, borderRadius: "50%", background: accent || "#ccc", display: "inline-block", flexShrink: 0 }} />
      <strong style={{ color: "#191919" }}>{value}</strong>
      <span>{label}</span>
    </span>
  );
}

function Badge({ count }) {
  if (!count || count < 1) return null;
  return (
    <span style={{
      background: "#FEF3C7",
      color: "#92400E",
      border: "1px solid #FCD34D",
      borderRadius: 10,
      fontSize: 11,
      fontWeight: 700,
      padding: "1px 7px",
      marginLeft: 6,
    }}>
      {count}
    </span>
  );
}

export default function AdminBanner({ dashState }) {
  const ws = dashState?.workspace_summary;
  if (!ws || ws.role === "solo") return null;

  // ── Teams Admin ────────────────────────────────────────────────────────────
  if (ws.role === "admin") {
    return (
      <div style={cardStyle}>
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <span style={{ fontSize: 15, fontWeight: 700, color: "#191919" }}>
              {ws.workspace_name || "Your Workspace"}
            </span>
            {ws.pending_invites > 0 && <Badge count={ws.pending_invites} />}
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" }}>
            <StatDot label="members" value={ws.member_count ?? 0} accent={BLUE} />
            <StatDot label="pending invites" value={ws.pending_invites ?? 0} accent={ws.pending_invites > 0 ? "#D97706" : "#ccc"} />
            <StatDot label="posts this week" value={ws.posts_this_week ?? 0} accent={GREEN} />
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <button
            style={btnPrimary}
            onClick={() => { window.location.hash = "/team"; }}
          >
            Manage Team
          </button>
        </div>
      </div>
    );
  }

  // ── Agency Admin ────────────────────────────────────────────────────────────
  if (ws.role === "agency_admin") {
    return (
      <div style={cardStyle}>
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          <span style={{ fontSize: 15, fontWeight: 700, color: "#191919" }}>
            {ws.agency_name || "Your Agency"}
          </span>
          <div style={{ display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" }}>
            <StatDot label="clients" value={ws.client_count ?? 0} accent={BLUE} />
            <StatDot label="team members" value={ws.total_members ?? 0} accent={GREEN} />
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <button
            style={btnSecondary}
            onClick={() => { window.location.hash = "/agency?action=add-client"; }}
          >
            Add Client
          </button>
          <button
            style={{ ...btnSecondary, color: "#555", borderColor: "#ccc" }}
            onClick={() => { window.location.hash = "/agency?tab=reports"; }}
          >
            Reports
          </button>
          <button
            style={btnPrimary}
            onClick={() => { window.location.hash = "/agency"; }}
          >
            Agency Dashboard
          </button>
        </div>
      </div>
    );
  }

  // ── Member ──────────────────────────────────────────────────────────────────
  if (ws.role === "member") {
    const adminName = ws.admin_name || "your admin";
    return (
      <div style={{ ...cardStyle, justifyContent: "flex-start", gap: 8 }}>
        <span style={{ fontSize: 13, color: "#555" }}>
          You are in a Team — Managed by {adminName}
        </span>
      </div>
    );
  }

  return null;
}
